function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.21 7.89998V16.05C21.21 19.07 19.32 21.2 16.3 21.2H7.65C4.63 21.2 2.75 19.07 2.75 16.05V7.89998C2.75 4.87998 4.64 2.75098 7.65 2.75098H16.3C19.32 2.75098 21.21 4.87998 21.21 7.89998Z",
  stroke: "#200E32",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.28125 16.4317L6.81025 14.8187C7.36125 14.2367 8.28625 14.2337 8.84225 14.8107L9.72725 15.7137C10.3242 16.3227 11.3172 16.2787 11.8582 15.6197L14.0872 12.9087C14.7272 12.1297 15.9012 12.0817 16.6022 12.8047L18.6782 14.9467",
  stroke: "#200E32",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3136 9.13388C10.3136 10.1019 9.52764 10.8879 8.55964 10.8879C7.59164 10.8879 6.80664 10.1019 6.80664 9.13388C6.80664 8.16588 7.59164 7.37988 8.55964 7.37988C9.52764 7.37988 10.3136 8.16588 10.3136 9.13388Z",
  stroke: "#200E32",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFileInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInput);
export default __webpack_public_path__ + "static/media/file-input.2ee708d2.svg";
export { ForwardRef as ReactComponent };